module.exports = __webpack_public_path__ + "static/media/maintitle.99f486d6.png";